import React, { useEffect, useState } from "react";
import { Button, Select } from "antd";

import arrowDown from "../../assets/icons/arrow-down12.png";
import addCircle from "../../assets/icons/add-circle.png";
import call from "../../assets/icons/call.svg";
import sms from "../../assets/icons/sms3.svg";

// import { controller } from "../../controller";

export default function DropdownColumn({
  allPatients,
  currentPatient, // The temp patient (the record)
  approvedPatients,
  setShowAddPatient,
  disabledByApproved,
  isSettingPatientId,
  selectedInsuranceID,
  setSelectedPatients,
  setIsSettingPatientId,
  approvedPredeterminations,
  setIsPatientDropdownEmpty,
  // setEmptyPatientDropdowns,
  predeterminationOrPostPayment,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(undefined);

  // Creating dropdown options
  const dropdownPatientsOptions = allPatients.map((patient) => ({
    value: patient.id,
    label: <SelectPatientDropDownItem name={`${patient.first_name} ${patient.last_name}`} phone={patient.phone} email={patient.email} />,
  }));

  // Update patient dropdown state
  useEffect(() => {
    const patientDropdown = selectedPatient ? selectedPatient.id : !currentPatient.is_temp ? currentPatient.id : undefined;

    if (!patientDropdown) {
      // setEmptyPatientDropdowns((prevEmptyPatientDropdowns) =>
      //   prevEmptyPatientDropdowns.includes(currentPatient.id) ? prevEmptyPatientDropdowns : [...prevEmptyPatientDropdowns, currentPatient.id]
      // );
      setIsPatientDropdownEmpty(true);
    } else {
      // setEmptyPatientDropdowns((prevEmptyPatientDropdowns) => prevEmptyPatientDropdowns.filter((patientID) => patientID !== currentPatient.id));
      setIsPatientDropdownEmpty(false);
    }
  }, [selectedPatient, currentPatient.id, currentPatient.is_temp, setIsPatientDropdownEmpty]);

  // Handle dropdown item change
  async function handleChangePatient(value) {
    // The patient that is selected from the dropdown and exists in my office
    const patient = allPatients.find((patient) => patient.id === value);

    setSelectedPatient(patient);
    setSelectedPatients((prevSelectedPatients) => ({ ...prevSelectedPatients, [currentPatient.id]: patient.id }));

    // try {
    //   setIsSettingPatientId(true);
    //   const response = await controller.setTreatmentPatientId({
    //     patient_id: patient.id,
    //     ...(!(selectedPatient || !currentPatient.is_temp) && { temporary_patient_id: currentPatient.id }),
    //     treatment_procedure_ids: currentPatient.insurances.map((insurance) => insurance.id),
    //     predetermination_file_id: selectedInsuranceID,
    //   });

    //   if (response.status < 250) {
    //     setEmptyPatientDropdowns((prevEmptyPatientDropdowns) => prevEmptyPatientDropdowns.filter((patientID) => patientID !== currentPatient.id));
    //     setIsPatientDropdownEmpty(false);
    //   }

    // } catch (err) {
    //   console.error("Error setting patient ID:", err);
    //   message.error("Something went wrong while setting the patient id.");
    // } finally {
    //   setIsSettingPatientId(false);
    // }
  }

  return (
    <Select
      showSearch
      placeholder="Select Patient"
      optionFilterProp="label"
      options={dropdownPatientsOptions}
      className={`select-patient-id ${(!currentPatient.is_temp || selectedPatient) && "no-transparent-background"}`}
      value={
        selectedPatient
          ? `${selectedPatient.first_name} ${selectedPatient.last_name}`
          : !currentPatient.is_temp
          ? `${currentPatient.first_name} ${currentPatient.last_name}`
          : undefined
      }
      suffixIcon={<img style={{ width: 20, transform: `rotate(${isOpen ? "180deg" : "0"})` }} src={arrowDown} alt="arrow-down" />}
      onChange={handleChangePatient}
      onOpenChange={(open) => setIsOpen(open)}
      disabled={
        isSettingPatientId ||
        disabledByApproved ||
        approvedPatients.includes(currentPatient.id) ||
        (predeterminationOrPostPayment === "predetermination" && approvedPredeterminations.includes(currentPatient.id))
      }
      filterOption={(input, option) => {
        if (!input) return true;
        if (!option.label) return false;

        return (
          (option.label.props.name && option.label.props.name.toLowerCase().includes(input.toLowerCase())) ||
          (option.label.props.email && option.label.props.email.toLowerCase().includes(input.toLowerCase())) ||
          (option.label.props.phone && option.label.props.phone.toString().toLowerCase().includes(input.toLowerCase()))
        );
      }}
      popupRender={(menu) => (
        <>
          {menu}
          <Button
            type="primary"
            style={{
              width: "100%",
              border: "1px solid #6B43B5",
              borderRadius: "0 0 10px 10px",
              backgroundColor: "white",
              color: "#6B43B5",
              padding: 30,
            }}
            onClick={() => setShowAddPatient(true)}
          >
            <img src={addCircle} alt="add" />
            Add New Patient
          </Button>
        </>
      )}
    />
  );
}

function SelectPatientDropDownItem({ name, email, phone }) {
  return (
    <div style={{ padding: "2px 4px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 5 }}>
        <p style={{ margin: 0, fontSize: 14 }}>{name}</p>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src={call} alt="phone" style={{ width: 15 }} />
          <span style={{ color: "#848696", fontSize: 12 }}>{phone}</span>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <img src={sms} alt="phone" style={{ width: 15 }} />
        <span style={{ color: "#848696", fontSize: 12 }}>{email}</span>
      </div>
    </div>
  );
}
